export default "__VITE_ASSET__C7JOgy_9__"